import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
import { taxCalculation, isDateRangeIn, values } from "./helper";
import { COURSE_TRIAL_DURATION_UNIT, CONTRACTABLE_BUFFER } from "@/lib/constants";
import dayjs from "@/lib/day";
import config from "@/lib/config";
import { GraphQLError } from "graphql";
export const typeDef = gql`
  type CoursePrice {
    id: ID
    price: Int
    payment_amount: Int
    validity_start_at: String
    validity_end_at: String
    validityEndAt: String
    campaignId: Int
    campaign: Campaign
  }

  type Course {
    id: ID!
    name: String!
    thumbnailUrl: String
    description: String
    validity_start_at: String
    validity_end_at: String
    price: Int
    priceWithoutTax: Int
    defaultPrice: Int
    defaultPriceWithoutTax: Int
    discount_price: Int
    active_pricing: CoursePrice
    rightIds: [Int]
    trial_flag: Boolean
    trial_date: String
    trialTerm: String
    trial_term_unit: String
    trialTermText: String
    trialText: String
    trialDate: String
    ref_id: String
    valuePlan: Boolean
    questionId: Int
    channel: ChannelMeta
    trialCampaignFlag: Boolean
    contractAllowed: Boolean
  }

  type Query {
    courseById(courseId: Int): Course
    courseByRightId(rightId: Int): Course
    courseByMetaId(metaId: Int): Course
  }
`;
export const resolvers = {
  Query: {
    courseById: async (_parent, _ref, _ref2) => {
      let {
        courseId
      } = _ref;
      let {
        dataSources
      } = _ref2;
      const res = await dataSources.courses.courseById(courseId);
      if (res) {
        return _objectSpread({}, res);
      } else {
        return null;
      }
    },
    courseByRightId: async (_parent, _ref3, _ref4) => {
      let {
        rightId
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      const res = await dataSources.right.courses(rightId);
      if (res) {
        return res.courses[0];
      } else {
        return null;
      }
    },
    courseByMetaId: async (_parent, _ref5, _ref6) => {
      var _channel$values;
      let {
        metaId
      } = _ref5;
      let {
        dataSources
      } = _ref6;
      const channel = await dataSources.meta.channelDetail(metaId);
      const right = channel === null || channel === void 0 || (_channel$values = channel.values) === null || _channel$values === void 0 || (_channel$values = _channel$values.rights) === null || _channel$values === void 0 ? void 0 : _channel$values[0];
      if (right) {
        const res = await dataSources.right.courses(right.id);
        return res.courses[0];
      } else {
        return null;
      }
    }
  },
  Course: {
    id: course => course.id || course.course_id,
    thumbnailUrl: (course, _args, _ref7) => {
      let {
        req
      } = _ref7;
      const noimage = "/images/noimage.png";
      return (course === null || course === void 0 ? void 0 : course.thumbnail_url) || noimage;
    },
    // キャンペーンが適用されていたらキャンペーンの価格になる
    price: course => {
      var _course$active_pricin;
      return course === null || course === void 0 || (_course$active_pricin = course.active_pricing) === null || _course$active_pricin === void 0 ? void 0 : _course$active_pricin.payment_amount;
    },
    priceWithoutTax: course => {
      var _course$active_pricin2;
      return course === null || course === void 0 || (_course$active_pricin2 = course.active_pricing) === null || _course$active_pricin2 === void 0 ? void 0 : _course$active_pricin2.price;
    },
    // course_pricingsの中からキャンペーンが設定されていない価格を取得する
    defaultPrice: (course, _args, _ref8, info) => {
      let {
        req
      } = _ref8;
      try {
        const price = course === null || course === void 0 ? void 0 : course.course_pricings.filter(cp => !(cp !== null && cp !== void 0 && cp.campaign) && !(cp !== null && cp !== void 0 && cp.campaign_id)).map(cp => cp.payment_amount).reduce((acc, current) => acc > current ? current : acc);
        return price;
      } catch (e) {
        var _info$operation, _info$operation2;
        throw new GraphQLError(e.message, {
          extensions: {
            code: "INTERNAL_SERVER_ERROR",
            operation: info === null || info === void 0 || (_info$operation = info.operation) === null || _info$operation === void 0 ? void 0 : _info$operation.operation,
            operationName: info === null || info === void 0 || (_info$operation2 = info.operation) === null || _info$operation2 === void 0 || (_info$operation2 = _info$operation2.name) === null || _info$operation2 === void 0 ? void 0 : _info$operation2.value,
            url: req === null || req === void 0 ? void 0 : req.url
          }
        });
      }
    },
    defaultPriceWithoutTax: (course, _args, _ref9, info) => {
      let {
        req
      } = _ref9;
      try {
        const price = course === null || course === void 0 ? void 0 : course.course_pricings.filter(cp => !(cp !== null && cp !== void 0 && cp.campaign) && !(cp !== null && cp !== void 0 && cp.campaign_id)).map(cp => cp.price).reduce((acc, current) => acc > current ? current : acc);
        return price;
      } catch (e) {
        var _info$operation3, _info$operation4;
        throw new GraphQLError(e.message, {
          extensions: {
            code: "INTERNAL_SERVER_ERROR",
            operation: info === null || info === void 0 || (_info$operation3 = info.operation) === null || _info$operation3 === void 0 ? void 0 : _info$operation3.operation,
            operationName: info === null || info === void 0 || (_info$operation4 = info.operation) === null || _info$operation4 === void 0 || (_info$operation4 = _info$operation4.name) === null || _info$operation4 === void 0 ? void 0 : _info$operation4.value,
            url: req === null || req === void 0 ? void 0 : req.url
          }
        });
      }
    },
    discount_price: async (course, _args, _ref10) => {
      var _right$values;
      let {
        dataSources
      } = _ref10;
      const refId = course === null || course === void 0 ? void 0 : course.ref_id;
      const right = await dataSources.right.rightsByRefId(refId);
      const discount_price = taxCalculation(right === null || right === void 0 || (_right$values = right.values) === null || _right$values === void 0 ? void 0 : _right$values.discount_price);
      return discount_price;
    },
    rightIds: course => course === null || course === void 0 ? void 0 : course.right_ids,
    valuePlan: course => {
      const id = course.id || course.course_id;
      return Number(id) === config.valuePlan.courseId;
    },
    trialCampaignFlag: async (course, _args, context) => {
      const [trialCampaignFlag] = await fakeTrialCampaignFlag(course, context);
      return trialCampaignFlag;
    },
    trialTerm: course => {
      if (course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit) {
        const unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
        return `${course.trial_term}${unit}`;
      }
    },
    trialTermText: async (course, _args, context) => {
      if (course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit) {
        const unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
        const [trialCampaignFlag, actual, fakeTrial] = await fakeTrialCampaignFlag(course, context);
        if (trialCampaignFlag && !actual) {
          return `${fakeTrial.term}${fakeTrial.unit}無料キャンペーン`;
        }
        return trialCampaignFlag ? `${course.trial_term}${unit}無料キャンペーン` : `${course.trial_term}${unit}無料トライアル`;
      }
      return null;
    },
    trialText: async (course, _args, _ref11) => {
      let {
        req,
        dataSources
      } = _ref11;
      if (course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit) {
        const unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
        const [trialCampaignFlag, actual, fakeTrial] = await fakeTrialCampaignFlag(course, {
          req,
          dataSources
        });
        if (trialCampaignFlag && !actual) {
          return `${fakeTrial.term}${fakeTrial.unit}無料キャンペーン`;
        }
        return trialCampaignFlag ? `${course.trial_term}${unit}無料キャンペーン` : "無料トライアル";
      }
      return null;
    },
    trialDate: course => {
      if (course.trial_date) {
        return dayjs(course.trial_date).format("YYYY/MM/DD");
      } else {
        return "";
      }
    },
    questionId: course => {
      var _course$values;
      const questionId = course === null || course === void 0 || (_course$values = course.values) === null || _course$values === void 0 ? void 0 : _course$values.question_id;
      if (typeof questionId === "object") {
        return questionId === null || questionId === void 0 ? void 0 : questionId.question_id;
      } else if (typeof questionId === "number") {
        return questionId;
      }
    },
    channel: async (parent, _args, _ref12) => {
      let {
        dataSources
      } = _ref12;
      if (parent !== null && parent !== void 0 && parent.ref_id) {
        var _res$values;
        const res = await dataSources.right.rightsByRefId(parent.ref_id);
        const channel = await dataSources.meta.channelDetail(res === null || res === void 0 || (_res$values = res.values) === null || _res$values === void 0 ? void 0 : _res$values.channel);
        return channel;
      }
    },
    contractAllowed: course => {
      return isDateRangeIn(course === null || course === void 0 ? void 0 : course.contractable_start_at, course === null || course === void 0 ? void 0 : course.contractable_end_at, {
        buffer: CONTRACTABLE_BUFFER,
        default: true
      });
    }
  },
  CoursePrice: {
    id: cp => cp.course_pricing_id,
    campaignId: cp => {
      var _cp$campaign;
      if (cp !== null && cp !== void 0 && cp.campaign_id) return Number(cp.campaign_id);
      if (cp !== null && cp !== void 0 && cp.campaign) return Number(cp === null || cp === void 0 || (_cp$campaign = cp.campaign) === null || _cp$campaign === void 0 ? void 0 : _cp$campaign.campaign_id);
      return null;
    }
  }
};

/**
  * @typedef FakeTrial
  * @property {number} term
  * @property {string} unit

/**
 * fakeTrialCampaignFlag.
 *
 * xx日間無料キャンペーン終了対応
 * 文言の出しわけにCourseのtrial_campaign_flagを使っているが、キャンペーン終了に伴いフラグがオフになる
 * フラグがオンのときにトライアルになったユーザーにはご利用状況ページでキャンペーン文言を出す必要がある
 * 特定のコースの場合にユーザーのsubscriptionの状態をみてフラグを偽装するようにする
 *
 * @param {Course} course
 * @param {Object} context
 * @param {Object} context.req
 * @param {Object} context.dataSources
 * @returns {Promise<(boolean|FakeTrial)[]>}
 */
async function fakeTrialCampaignFlag(course, _ref13) {
  let {
    req,
    dataSources
  } = _ref13;
  const courseId = course.id || course.course_id;
  const target = config.trialCamapignTextDisplay.find(v => v.courseId === courseId);
  if (target && req.userToken) {
    // サブスクリプションを取得
    const subscription = await dataSources.subscribe.subscriptionFromCourseId(courseId);
    if (subscription && (subscription === null || subscription === void 0 ? void 0 : subscription.status) === "trial") {
      // if (subscription && subscription?.status === "trial") {
      // トライアル開始日時がendAt以前であればキャンペーンとみなす
      const trialStartAt = dayjs(new Date(subscription.trial_start_at));
      return [trialStartAt.isSameOrBefore(target.endAt, "secound"), false, {
        term: target.term,
        unit: target.unit
      }];
    }
  }
  return [!!values(course, "trial_campaign_flag"), true];
}